import { userAtom } from '@/global-store';
import navigation from '@/navigation';
import { useAtom } from 'jotai';
import { useMemo } from 'react';
import { allowedToShowItem } from './allowedToShowItem';
import NavItem from '@layout/Sidebar/MenuList/NavItem.tsx';
import NavCollapse from '@layout/Sidebar/MenuList/NavCollapse';
import HeaderActions from '@layout/Header/HeaderActions';
import type { MenuItem } from '@layout/Sidebar/MenuList/types';
import { useTailwindBreakpoint } from '@eye-able/ui';
import { T } from '@/i18n/T';

export default function MenuList() {
  const xlAndUp = useTailwindBreakpoint('xl');
  const [user] = useAtom(userAtom);

  const allowedItems = useMemo<MenuItem[]>(() => {
    return navigation.filter((item) => {
      return allowedToShowItem(item.handle.access, user, item.path);
    });
  }, [user]);

  const items = allowedItems.flatMap((item) => {
    const type = item.handle.type;

    const id_path = item.path.replaceAll('/', '-');
    const NavComponent = type === 'collapse' ? NavCollapse : NavItem;

    return [
      item.handle.showDividerBeforeThis && (
        <li
          key={`divider-${item.path}`}
          aria-hidden='true'
          role='separator'
          className='eye:pl-48 eye:headline-xs eye:text-14 eye:font-bold eye:mt-xs'
        >
          {item.handle.i18nDividerKey ? (
            <T k={item.handle.i18nDividerKey} />
          ) : null}
        </li>
      ),
      (type === 'collapse' || type === 'item') && (
        <li key={item.path} id={`${type}${id_path}`}>
          <NavComponent level={1} item={item} />
        </li>
      ),
    ].filter(Boolean);
  });

  if (!user) return null;

  return (
    <ul className='no-print eye:flex eye:flex-col eye:flex-1 eye:min-h-0 eye:w-full eye:xl:pt-48'>
      {xlAndUp ? null : (
        <li className='eye:flex eye:flex-col eye:w-full eye:items-center eye:justify-center'>
          <HeaderActions />
          <hr
            className='eye:w-full'
            style={{ color: 'var(--color-grey-20)' }}
          />
        </li>
      )}
      {items}
    </ul>
  );
}
